/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const tooltip = () => {
  const showTooltip = document.querySelectorAll('.js-show-tooltip');
  const closeTooltip = document.querySelectorAll('.js-close-tooltip');

  showTooltip.forEach(item => {
    const tooltipText = item.parentElement.querySelector('.js-tooltip-text');

    item.addEventListener(
      'click',
      event => {
        tooltipText.classList.add('is-active');
      },
      true,
    );

    // close tooltip when clicked outside of tooltip or outside of show tooltip icon
    document.addEventListener('click', event => {
      if (!item.contains(event.target) && !tooltipText.contains(event.target)) {
        tooltipText.classList.remove('is-active');
      }
    });
  });
  closeTooltip.forEach(item => {
    const tooltipText = item.parentElement;

    item.addEventListener(
      'click',
      event => {
        tooltipText.classList.remove('is-active');
      },
      true,
    );
  });
};

export default tooltip;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/tooltip.js